import { Component, Prop, h, State } from '@stencil/core';
import state from '@ugc-store';
import { FontType, handleErrorMessage, showToast, toLocalSeparator } from '@ugc-utils/utils';
import { LinedThumbsUp, LinedThumbsDown } from '../../../icons';
import { postHelpful } from '@ugc-api/review';

@Component({
  tag: 'ugc-review-vote',
  shadow: false,
})
export class UgcReviewVote {
  @Prop() fontType: FontType = FontType.large;
  @Prop() rid: string;
  @Prop() hasThumbsUp: boolean | null;
  @Prop() helpfulYes: number;
  @Prop() helpfulNo: number;
  @State() IsVote: boolean | null = null;

  async handleHelpful(isHelpful) {
    const {
      actionPermission: { vote: voteButtonDisabled },
      reviewStaticLanguage: { IDS_TXT_FEEDBACK_HAS_BEEN_SUBMITTED = '' },
    } = state;

    if (voteButtonDisabled || typeof this.hasThumbsUp === 'boolean' || this.IsVote !== null) {
      return;
    }

    try {
      await postHelpful(this.rid, isHelpful);
      showToast({
        type: 'success',
        message: [IDS_TXT_FEEDBACK_HAS_BEEN_SUBMITTED || ''],
      });
      this.IsVote = isHelpful;
    } catch (e) {
      handleErrorMessage(e);
    }
  }

  render() {
    const {
      actionPermission: { vote: voteButtonDisabled },
    } = state;
    const voteTextClass = voteButtonDisabled ? 'color-gray-400' : 'color-gray-600';
    const isLargeType = this.fontType === FontType.large;
    const iconSize = isLargeType ? '24' : '16';
    const isCanVote = !(voteButtonDisabled || typeof this.hasThumbsUp === 'boolean' || this.IsVote !== null);
    return (
      <div class="flex-row-start-center gap-4">
        <ugc-button type="text" class="flex-row-start-center" disabled={!isCanVote} data-testid="pdp-review-thumbs-up">
          <span class={`flex-row-start-center gap-4`} onClick={() => this.handleHelpful(true)}>
            <LinedThumbsUp
              width={iconSize}
              height={iconSize}
              selected={this.hasThumbsUp === true || this.IsVote === true}
              disabled={voteButtonDisabled}
            />
            <span class={`${isLargeType ? 'fs-16' : 'fs-14'} ${voteTextClass}`}>
              {toLocalSeparator(this.IsVote === true ? this.helpfulYes + 1 : this.helpfulYes)}
            </span>
          </span>
        </ugc-button>
        <ugc-button
          type="text"
          class="flex-row-start-center"
          disabled={!isCanVote}
          data-testid="pdp-review-thumbs-down"
        >
          <span class="flex-row-start-center gap-4" onClick={() => this.handleHelpful(false)}>
            <LinedThumbsDown
              width={iconSize}
              height={iconSize}
              selected={this.hasThumbsUp === false || this.IsVote === false}
              disabled={voteButtonDisabled}
            />
            <span class={`${isLargeType ? 'fs-16' : 'fs-14'} ${voteTextClass}`}>
              {toLocalSeparator(this.IsVote === false ? this.helpfulNo + 1 : this.helpfulNo)}
            </span>
          </span>
        </ugc-button>
      </div>
    );
  }
}
